import { isNaN } from "lodash-es";
import { SIZES } from "../constants/SIZE";

export const getAddSizeUnit = (size) => {
  return !isNaN(Number(size)) ? size + "px" : size;
};

export const getSize = (size = "md") => {
  let _size = size.toLowerCase();
  SIZES.forEach(({ labels, label }) => {
    if (labels.includes(_size)) _size = label;
  });
  return _size;
};
